export class Uid {
  static generate(): string {
    return `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
  }
}
